import { ExerciseEnvironment } from '@datacamp/exercise-contract';
import split from 'lodash/split';

const env = process.env.NODE_ENV;
const ecsEnv = process.env.REACT_APP_ECS_ENV || 'development';
const IS_SSR = process.env.REACT_APP_IS_SSR;
const RELEASE = process.env.REACT_APP_RELEASE;

export default {
  env,
  ecsEnv,
  release: RELEASE,
  isProductionEnv: env === 'production',
  isProductionDomain: () => ecsEnv === 'production',
  getStandaloneExerciseEnvironment: () => {
    switch (ecsEnv) {
      case 'production':
        return ExerciseEnvironment.PRODUCTION;
      case 'staging':
        return ExerciseEnvironment.STAGING;
      case 'development':
      default:
        return ExerciseEnvironment.DEVELOPMENT;
    }
  },
  isServerSideRendering: IS_SSR === 'true',
  serveStaticFiles: process.env.SERVE_STATIC_FILES === 'true',
  isMathjaxDeactivated: process.env.REACT_APP_DEACTIVATE_MATHJAX === 'true',
  sentryEnabled: process.env.REACT_APP_SENTRY_DISABLED !== 'true',
  allowedOrigins: split(process.env.ALLOWED_ORIGINS, ','),
  tracerServiceName: process.env.TRACER_SERVICE_NAME,
  tracerEnabled: process.env.TRACER_ENABLED === 'true',
  tracerHostname: process.env.TRACER_HOSTNAME,
  tracerPort: process.env.TRACER_PORT,
  appName: 'campus-app',
  postMessageTargetOrigin:
    process.env.REACT_APP_POST_MESSAGE_TARGET_ORIGIN || '*',
  urls: ((e) => {
    switch (e) {
      case 'dev':
      case 'development':
      case 'staging':
        return {
          aiApi: 'https://ai-api.datacamp-staging.com',
          workspace: 'https://app.datacamp-staging.com/workspace',
          collabApi: 'https://collab-api.datacamp-staging.com',
          datacamp: 'https://www.datacamp-staging.com',
          teach: 'https://teach-api.datacamp-staging.com/teach-app',
          campusApi: 'https://campus-api.datacamp-staging.com',
          multiplexer: 'https://sessions.datacamp-staging.com',
          rdoc: 'https://staging.rdocumentation.org',
          imb: 'https://imb.datacamp-staging.com',
          timetracker: 'https://timetracker.datacamp-staging.com',
          trackingGenerator: 'https://compliance.datacamp-staging.com',
          assets: 'https://assets.datacamp.com',
          projector: 'https://projector.datacamp-staging.com',
          googleSheets: 'https://spreadsheets.datacamp-staging.com',
          prometheusAggregator:
            'https://prometheus-aggregator.datacamp-staging.com',
          mobile: 'https://mobile-api.datacamp-staging.com',
          cas: 'https://content-authorization.datacamp-staging.com',
          learn: 'https://app.datacamp-staging.com/learn',
          groupHubApi: 'https://www.datacamp-staging.com/groups/graphql',
          learnDatawarehouseApi:
            'https://learn-datawarehouse-api.datacamp-staging.com',
        };
      default:
        return {
          aiApi: 'https://ai-api.datacamp.com',
          workspace: 'https://app.datacamp.com/workspace',
          collabApi: 'https://collab-api.datacamp.com',
          datacamp: 'https://www.datacamp.com',
          teach: 'https://teach-api.datacamp.com/teach-app',
          campusApi: 'https://campus-api.datacamp.com',
          multiplexer: 'https://sessions.datacamp.com',
          betaMultiplexer: 'https://multiplexer-beta.datacamp.com',
          rdoc: 'https://www.rdocumentation.org',
          imb: 'https://imb.datacamp.com',
          timetracker: 'https://timetracker.datacamp.com',
          trackingGenerator: 'https://compliance.datacamp.com',
          assets: 'https://assets.datacamp.com',
          projector: 'https://projector.datacamp.com',
          googleSheets: 'https://spreadsheets.datacamp.com',
          prometheusAggregator: 'https://prometheus-aggregator.datacamp.com',
          mobile: 'https://mobile-api.datacamp.com',
          cas: 'https://content-authorization.datacamp.com',
          learn: 'https://app.datacamp.com/learn',
          groupHubApi: 'https://www.datacamp.com/groups/graphql',
          learnDatawarehouseApi: 'https://learn-datawarehouse-api.datacamp.com',
        };
    }
  })(ecsEnv),
};
